import { useEffect, useRef } from 'react';
import { useNotificationsAllQuery } from '../queries/notifications.queries';
import { useSnackbar } from 'notistack';
import NotificationTemplate from 'app/shared-components/notificationPanel/NotificationTemplate';
import useGetStartedDialogStore from '../store/getStartedDialogSlice';

export function useNotificationListener() {
  const { data: result } = useNotificationsAllQuery();
  const notifications = result?.data.items || [];
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const lastNotificationRef = useRef<number | null>(null);
  const { shouldHoldNotifications } = useGetStartedDialogStore();
  const pendingNotificationsRef = useRef<typeof notifications>([]);

  useEffect(() => {
    if (!shouldHoldNotifications && pendingNotificationsRef.current.length > 0) {
      const pendingNotification =
        pendingNotificationsRef.current[pendingNotificationsRef.current.length - 1];
      showNotification(pendingNotification, pendingNotificationsRef.current.length - 1);
      pendingNotificationsRef.current = [];
    }
  }, [shouldHoldNotifications]);

  useEffect(() => {
    const undeliveredNotifications = notifications.filter((n) => !n.delivered);

    if (undeliveredNotifications.length > 0) {
      if (shouldHoldNotifications) {
        pendingNotificationsRef.current = undeliveredNotifications;
        return;
      }

      const latestNotification = undeliveredNotifications[undeliveredNotifications.length - 1];
      showNotification(latestNotification, undeliveredNotifications.length - 1);
    }
  }, [result]);

  const showNotification = (notification, counter) => {
    if (lastNotificationRef.current) {
      closeSnackbar(lastNotificationRef.current);
    }

    enqueueSnackbar('', {
      variant: 'info',
      key: notification.id,
      autoHideDuration: 4000,
      content: () => (
        <NotificationTemplate
          item={notification}
          onClose={() => {
            closeSnackbar(notification.id);
          }}
          counter={counter > 0 ? counter : 0}
        />
      ),
    });

    lastNotificationRef.current = notification.id;
  };
}
